type BooleanSwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  onLabel: string;
  offLabel: string;
};

const BooleanSwitch = ({
  value,
  onChange,
  onLabel,
  offLabel,
}: BooleanSwitchProps) => {
  return (
    <div className="inline-flex rounded-e rounded-s border border-gray-200 bg-white shadow-sm">
      <div
        role="button"
        tabIndex={0}
        onClick={() => onChange(false)}
        className={`cursor-pointer rounded-s px-4 py-2 text-sm font-medium transition-colors ${
          !value
            ? "bg-blue-600 text-white shadow-sm"
            : "bg-white text-gray-600 hover:bg-gray-50"
        }`}
      >
        {offLabel}
      </div>
      <div
        role="button"
        tabIndex={0}
        onClick={() => onChange(true)}
        className={`cursor-pointer rounded-e px-4 py-2 text-sm font-medium transition-colors ${
          value
            ? "bg-blue-600 text-white shadow-sm"
            : "bg-white text-gray-600 hover:bg-gray-50"
        }`}
      >
        {onLabel}
      </div>
    </div>
  );
};

export default BooleanSwitch;
